const fallbackName = (companyName) => {
  if (companyName.startsWith("Diamond")) 
  {
    return "Diamond Pet Food";
  }
  return companyName;
};

export { fallbackName };